import React from 'react';
import './BlockLink.scss';

interface IBlockLink {
    path: string;
    label: string; 
    language: string;
}

class BlockLink extends React.Component<IBlockLink, any> {
    props: IBlockLink;
    
    constructor(props: IBlockLink) {
        super(props);
        this.props = props;
    }

    render() {
        return (
            <div className="BlockLink">
                <a href={"/" + this.props.language + "/" + this.props.path }>{ this.props.label }</a>
            </div>
        );
    }
}

export default BlockLink;